var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"fill-in-the-blank"}},[_c('span',{directives:[{name:"katex",rawName:"v-katex:auto",arg:"auto"}],domProps:{"innerHTML":_vm._s(_vm.toFibText(_vm.content.resource.text))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }